import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../common';
import { PublicProofOfDeliveryFacade } from './public-proof-of-delivery.facade';

@Injectable({
  providedIn: 'root',
})
export class PublicProofOfDeliveryGuard {
  constructor(private publicProofOfDeliveryFacade: PublicProofOfDeliveryFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      queryParams: { token },
    } = route;
    return checkStoreState(this.publicProofOfDeliveryFacade, token);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.publicProofOfDeliveryFacade);
  }
}
